export default "__VITE_ASSET__CI6LAHdv__"